import { lazy } from 'react';

export const CommonSettingsPageLazy = lazy(() => import('./CommonSettingsPage'));
